import { useEffect } from "react";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { TeamworkCollectionPricingPageTemplate } from "@/templates/collections/teamwork/pricing/teamwork-collection-pricing-page.template.tsx";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface TeamworkCollectionPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
}

export const TeamworkCollectionPricingPage = (
    props: TeamworkCollectionPricingPageProps
) => {
    const { pricingContent, pricing, countryCode } = props;

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="teamwork-collection"
            pricingContent={pricingContent}
        >
            <TeamworkCollectionPricingPageTemplate />
        </PricingContentContextProvider>
    );
};
